// extracted by mini-css-extract-plugin
export default {"root":"Reviews_root__SG4Eq","reviewItem":"Reviews_reviewItem__ax7Fo"};